<template>
    <div class="margin">
        <content-item-container :showWord="true" wordPosition="right">
            <div class="reward-first">
                <div class="title-box">
                    <img class="reward-title" src="../../../assets/images/postalNewCustomer/reward_content_title_2.png">
                </div>
                <div class="img-box">
                    <img class="reward-img" src="../../../assets/images/postalNewCustomer/index_reward_second.png">
                    <div class="text-box-second" @click="instructionOpen(2)"></div>
                    <img class="icons" v-if="rewardSecond == 1" src="../../../assets/images/postalNewCustomer/icon_get.png">
                    <img class="icons" v-if="rewardSecond == 2" src="../../../assets/images/postalNewCustomer/icon_over.png">
                </div>
                <div class="reward-text text-second">未开通邮储数币钱包的新用户，报名后24小时内<span>首次开通中国邮政储蓄银行数字人民币钱包</span>，还可以领取额外数字人民币红包！</div>
            </div>
        </content-item-container>
    </div>
</template>

<script>
import contentItemContainer from './ContentItemContainer.vue'

export default {
    components: { contentItemContainer },
    props: {
        rewardSecond: {
            type: [Number, String],
            default: 0
        }
    },
    data() {
        return {}
    },
    computed: {},
    created() { },
    mounted() { },
    beforeDestroy() { },
    methods: {
        instructionOpen(num) {
            this.$emit('instructionOpen', num)
        }
    },
}
</script>

<style lang="scss" scoped>
@import "./function";
.margin {
    margin-bottom: pxvw(20);
}
.reward-first {
    padding: pxvw(32) 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .title-box {
        width: pxvw(625);
    }
    .img-box {
        position: relative;
        .text-box-second {
            right: pxvw(161);
            bottom: pxvw(33);
            position: absolute;
            width: pxvw(82);
            height: pxvw(20);
        }
        .icons {
            position: absolute;
            right: pxvw(-15);
            bottom: pxvw(-23);
            width: pxvw(123);
            height: pxvw(123);
        }
    }
    .reward-img {
        width: pxvw(625);
        margin-top: pxvw(19);
    }
    .reward-title {
        font-size: 0;
        height: pxvw(68);
    }
    .text-center {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .reward-text {
        text-align: justify;
        color: #898989;
        line-height: pxvw(40);
        margin-top: pxvw(14);
        font-size: pxvw(22);
        width: pxvw(580);
        span {
            color: #1db9b2;
        }
    }
}
</style>